import React, { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhoWeAre from "@/components/site/WhoWeAre";
import MeetTheTeam from "@/components/site/MeetTheTeam";
import Services from "@/components/site/Services";
import WhyAceMax from "@/components/site/WhyAceMax";
import SuccessStories from "@/components/site/SuccessStories";
import TennisShowcase from "@/components/site/TennisShowcase";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ContactModal from "@/components/site/ContactModal";

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  return (
    <main data-testid="home-page" className="bg-white text-navy-deeper selection:bg-gold selection:text-navy overflow-x-hidden">
      <Navbar onBookConsultation={openModal} />
      <Hero onBookConsultation={openModal} />
      <WhoWeAre />
      <MeetTheTeam />
      <Services />
      <TennisShowcase onBookConsultation={openModal} />
      <WhyAceMax />
      <SuccessStories />
      <Contact onBookConsultation={openModal} />
      <Footer />
      <ContactModal open={modalOpen} onOpenChange={setModalOpen} />
    </main>
  );
}
